// bookingReducer.js
const initialState = {
    weekOffset: 0,
    selectedSlot: null,
    appointmentType: 'Physical',
    bookingError: false,
    bookingSuccess: false,
  };
  
  export default function bookingReducer(state = initialState, action) {
    switch (action.type) {
      case 'SET_WEEK_OFFSET':
        return { ...state, weekOffset: action.payload };
      case 'SELECT_SLOT':
        return { ...state, selectedSlot: action.payload };
      case 'SET_APPOINTMENT_TYPE':
        return { ...state, appointmentType: action.payload };
      case 'SET_BOOKING_ERROR':
        return { ...state, bookingError: action.payload };
      case 'SET_BOOKING_SUCCESS':
        return { ...state, bookingSuccess: action.payload };
      default:
        return state;
    }
  }
  